import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ToastService} from "../../../service/toast.service";
import {AppToast, ExtendedToastModel, ToastType} from "../toast.model";
import {IconComponent} from "../../icon/icon.component";

import {IconId} from '../../icon/icon.types';
@Component({
    selector: 'app-toast',
    templateUrl: './my-toast.component.html',
    styleUrls: ['./my-toast.component.scss'],
    imports: [IconComponent],
    standalone: true
})
export class MyToastComponent implements OnInit, OnDestroy {

    toasts: AppToast[] = [];
    private toastSubscription: Subscription;

    constructor(
        private toastService: ToastService,
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.toastSubscription = this.toastService.subscribe(ToastType.TOAST, payload => {
            this.show(payload);
        });
    }

    ngOnDestroy(): void {
        this.toastSubscription.unsubscribe();
        this.toasts = [];
    }

    show(payload: ExtendedToastModel): void {
        const header = this.translateService.instant(payload.title as string);
        const body = payload.content ? this.translateService.instant(payload.content as string) : '';
        const toast: AppToast = {header, body, classname: '', delay: payload.timeOut || 7000, level: payload.level};

        this.toasts.push(toast);
        setTimeout(() => this.remove(toast), toast.delay);
    }

    remove(toast: AppToast): void {
        this.toasts = this.toasts.filter(t => t !== toast);
    }

    levelAlertClass(level: string | undefined): string {
        switch (level) {
            case 'success': return 'alert-success';
            case 'danger':  return 'alert-error';
            case 'warning': return 'alert-warning';
            default:        return 'alert-info';
        }
    }

    levelIcon(level: string | undefined): IconId {
        switch (level) {
            case 'success': return 'app:success';
            case 'danger':  return 'ph:x-circle';
            case 'warning': return 'app:warning';
            default:        return 'app:info';
        }
    }
}
